module.exports = __webpack_public_path__ + "static/media/NZ_DRIVER_LICENSE_HINT.9c23fe7c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/NZ_DRIVER_LICENSE_HINT.png
 ** module id = 1295
 ** module chunks = 0
 **/